import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { UserActionItem } from '../models/userActionItem.model';
import { Observable } from 'rxjs';
import { UserActionItemDetails } from '../models/userActionItemDetails.model';
import { UserActionItemType } from '../models/userActionItemType.model';

export interface UserActionItemTypesResponse {
  today: UserActionItemType[];
  requests: UserActionItemType[];
}

export interface UserActionItemsPaginatedResponse {
  current_page: number;
  data: UserActionItem[];
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserActionItemsService {

  baseItemUrl = '/user-action-item';
  baseUrl = '/user-action-items';

  /**
   * @param http - Injected http client service.
   */
  constructor(
    private http: ApiHttpClient
  ) {}

    /**
     * Get all requirements for a LenderUser.
     *
     * @returns Http response as Observable<[]>.
     */
    getUserActionItems(
      userId: number,
      page: number,
      types: Array<number>,
      sortDirection: string,
      completed: boolean = false
    ): Observable<UserActionItemsPaginatedResponse> {
      const options = {
        params: {
          page,
          sortDirection,
          types: JSON.stringify(types),
          completed,
        }
      };
      return this.http.get<UserActionItemsPaginatedResponse>(`${this.baseUrl}/${userId}`, options);
    }

    getUserActionItemsCount(userId: number): Observable<number> {
      return this.http.get<number>(`${this.baseUrl}/${userId}/count`);
    }

    getUserActionItemDetails(actionItemId: number): Observable<UserActionItemDetails> {
      return this.http.get<UserActionItemDetails>(`${this.baseItemUrl}/${actionItemId}/details`);
    }

    getUserActionItemTypes(): Observable<UserActionItemTypesResponse> {
      return this.http.get<UserActionItemTypesResponse>(`${this.baseUrl}/types`);
    }

    getUserActionItemByDocId(documentId: number): Observable<UserActionItemDetails> {
      return this.http.get<UserActionItemDetails>(`${this.baseItemUrl}/document-review-item/${documentId}`);
    }

    completeTaskById(taskId: number, lenderUserId: number) {
      const body = {completedByUserId: lenderUserId};
      return this.http.put<UserActionItem>(`/task/${taskId}/complete`, body);
    }

    markActionItemComplete(id: number) {
      return this.http.post<UserActionItem>(`/user-action-item/${id}/complete`, {});
    }
}

